import React, { useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import QuestionContainer from './QuestionContainer'
import { date, required } from '../../../../utilties/validators'
import FormAnalogQuestion from './FormAnalogQuestion'
import { change, formValueSelector } from 'redux-form'
import { useSelector } from 'react-redux'

export default ({
	question,
	position,
	positionDisplay,
	meta: { touched, invalid, error, form, dispatch },
	disabled,
	onQuestionValueChanged,
	isBilateral,
	isBilateralFullInfo,
	displayInstructionAsIcon,
	uniqueKey
}) => {
	const isLabelContainerPreserved = !!isBilateral && !!isBilateralFullInfo
	const name = `answers.analog._${question.uniqueId}._${uniqueKey ?? ''}`

	const selector = formValueSelector(form)
	const currentValue = useSelector((state) => selector(state, name))

	const onRemoveAnswer = () => {
		onQuestionValueChanged(question, null, undefined, undefined)

		dispatch(change(form, name, null))
	}

	useEffect(
		() => {
			if (question.value !== currentValue) {
				onQuestionValueChanged(question, currentValue)
			}
		},
		[currentValue]
	)

	return (
		<Grid>
			<QuestionContainer
				data-testid="question-container"
				title={`${question.title}`} titleRequered = {`${question.isOptional ? '' : ' *'}`}
				position={position}
				positionDisplay={positionDisplay}
				instructions={question.instructions}
				canRemoveAnswer={question.isOptional && (currentValue || currentValue === 0)}
				onRemoveAnswer={onRemoveAnswer}
				isBilateral={isBilateral}
				displayInstructionAsIcon={displayInstructionAsIcon}
				children={
					<Grid
						container
					>
						{
							!!isLabelContainerPreserved
							&& <Grid xs={6} />
						}
						<Grid
							item
							xs={isLabelContainerPreserved ? 6 : 12}
						>
							<FormAnalogQuestion
								question={question}
								disabled={disabled}
								inputName={name}
							/>
						</Grid>
					</Grid>
				}
			/>
		</Grid>
	)
}
